import { render, staticRenderFns } from "./RssCard.vue?vue&type=template&id=3a200a7d&"
import script from "./RssCard.vue?vue&type=script&lang=js&"
export * from "./RssCard.vue?vue&type=script&lang=js&"
import style0 from "./RssCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText,VCardTitle})
